import { EAuthenticateError, EAuthenticateStatus } from '../../types/social';
export function socialErrorSelector(state) {
  var _state$social$authent = state.social.authenticate,
    status = _state$social$authent.status,
    errorType = _state$social$authent.errorType,
    error = _state$social$authent.error;
  var hasError = status === EAuthenticateStatus.Failed && (!errorType || ![EAuthenticateError.EmailRequired, EAuthenticateError.EmailTaken].includes(errorType));
  return hasError && error || undefined;
}
export function expandedSelector(state) {
  return state.social.expanded;
}